export const AVAILABLE = 'available';
export const UNAVAILABLE = 'unavailable';
export const NEEDS_ACTIVATION = 'needs_activation';
export const SUBSCRIBABLE = 'subscribable';
